import React, { useState } from 'react';
import './App.css';
import Home from "./Home";
import Login from './pages/Login_Signup/index.js';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const handleLogin = (value) => {
    setIsLoggedIn(value)
  }
  return (
    <div>
      {isLoggedIn ? <Home handleLogin={handleLogin}/> : <Login handleLogin={handleLogin} />}
    </div>

  );
};

export default App;
